define(function (require) {

    var Ajv = require('ajv');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var quickRepliesSchema = require('json-schemas/quickReplies/quickReplies');
    var buttonSchema = require('json-schemas/rich/button');
    var styleSchema = require('json-schemas/rich/style');
    var actionSchema = require('json-schemas/rich/action');
    var metadataSchema = require('json-schemas/metadata/metadata');
    var actionReasonSchema = require('json-schemas/metadata/actionReason');
    var answerSchema = require('json-schemas/metadata/answer');
    var appleBusinessChatCustomMessageSchema = require('json-schemas/metadata/appleBusinessChatCustomMessage');
    var appleBusinessChatMessageSchema = require('json-schemas/metadata/appleBusinessChatMessage');
    var botResponseSchema = require('json-schemas/metadata/botResponse');
    var businessEventSchema = require('json-schemas/metadata/businessEvent');
    var escalationSummarySchema = require('json-schemas/metadata/escalationSummary');
    var externalIdSchema = require('json-schemas/metadata/externalId');
    var IBMWatsonInfoSchema = require('json-schemas/metadata/IBMWatsonInfo');
    var invalidAnswerSchema = require('json-schemas/metadata/invalidAnswer');
    var questionSchema = require('json-schemas/metadata/question');
    var surveySchema = require('json-schemas/metadata/survey');
    var predefinedResponseSchema = require('json-schemas/metadata/predefinedResponse');

    // Polyfill
    // TODO: Remove when babel solve ES6
    if (!Object.entries) {
        Object.entries = function (obj) {
            var ownProps = Object.keys(obj);
            var i = ownProps.length;
            var resArray = new Array(i); // preallocate the Array
            while (i--) {
                resArray[i] = [ownProps[i], obj[ownProps[i]]];
            }

            return resArray;
        };
    }

    var KEYS = {
        QUICK_REPLIES: 'quickReplies'
    };

    var schemasMap = {
        quickReplies: {
            root: quickRepliesSchema,
            dependencies: {
                'rich/button.json': buttonSchema,
                'style.json': styleSchema,
                'action.json': actionSchema,
                'metadata/metadata.json': metadataSchema,
                'actionReason.json': actionReasonSchema,
                'answer.json': answerSchema,
                'appleBusinessChatCustomMessage.json': appleBusinessChatCustomMessageSchema,
                'appleBusinessChatMessage.json': appleBusinessChatMessageSchema,
                'botResponse.json': botResponseSchema,
                'businessEvent.json': businessEventSchema,
                'escalationSummary.json': escalationSummarySchema,
                'externalId.json': externalIdSchema,
                'IBMWatsonInfo.json': IBMWatsonInfoSchema,
                'invalidAnswer.json': invalidAnswerSchema,
                'question.json': questionSchema,
                'survey.json': surveySchema,
                'predefinedResponse.json': predefinedResponseSchema
            }
        }
    };

    var logger = WebAgentLogger.getLogger('SchemaValidator');

    var ajv = new Ajv({
        format: 'full',
        unknownFormats: 'ignore',
        verbose: true,
        logger: false
    });

    var getValidator = function (schemaSet) {
        if (!schemaSet.validator) {
            Object.entries(schemaSet.dependencies)
                .forEach(function (arr) {
                    var id = arr[0];
                    var schema = arr[1];
                    ajv.addSchema(schema, id);
                });
            schemaSet.validator = ajv.compile(schemaSet.root);
        }
        return schemaSet.validator;
    };

    var validate = function (key, instance) {
        var schemaSet = schemasMap[key];
        if (!schemaSet) {
            throw new Error('no schemas found in map for key [' + key + '], make sure the key is ok');
        }

        var validator = getValidator(schemaSet);
        validator(instance);
        if (validator.errors) {
            logger.error(validator.errors);
            throw new Error('schema validation failed');
        }
    };

    return {
        KEYS: KEYS,
        validate: validate
    };

});
